/* Étampes A+ — sélecteur d'encres panier (V2 : défilement libre + fermeture).
   Installation: charger ce fichier DEPUIS layout/theme.liquid, avant </body>.
   Délégation d'événements : reste actif lors du morphing AJAX de Horizon.
   Ajouts multiples par Shopify.actions.updateCart : préserve BO/personnalisation.
*/
(() => {
  'use strict';
  if (window.__eaCartInkSelectorV1) return;
  window.__eaCartInkSelectorV1 = true;

  const selector = '[data-ea-ink-addon]';
  const maxQty = 99;
  const getLocale = (panel) => panel.dataset.eaInkLocale === 'en' ? 'en' : 'fr';
  const tr = (panel, fr, en) => getLocale(panel) === 'en' ? en : fr;

  function numberOf(input) {
    const parsed = Number.parseInt(input?.value ?? '0', 10);
    return Number.isFinite(parsed) ? Math.min(maxQty, Math.max(0, parsed)) : 0;
  }

  function refresh(panel) {
    if (!panel) return;
    let count = 0;
    let amount = 0;
    for (const row of panel.querySelectorAll('[data-ea-ink-row]')) {
      const input = row.querySelector('[data-ea-ink-quantity]');
      if (!input) continue;
      const qty = numberOf(input);
      input.value = String(qty);
      row.querySelector('[data-ea-ink-step="-1"]')?.toggleAttribute('disabled', qty === 0);
      row.querySelector('[data-ea-ink-step="1"]')?.toggleAttribute('disabled', qty >= maxQty);
      count += qty;
      amount += qty * (Number(row.dataset.eaInkPrice) || 0);
    }
    const button = panel.querySelector('[data-ea-ink-submit]');
    const label = panel.querySelector('[data-ea-ink-submit-label]');
    if (!button || !label) return;
    const currency = panel.dataset.eaInkCurrency || 'CAD';
    const locale = getLocale(panel) === 'en' ? 'en-CA' : 'fr-CA';
    const formatted = new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount / 100);
    label.textContent = count
      ? tr(panel, `Ajouter ${count} bouteille${count > 1 ? 's' : ''} au panier · ${formatted}`, `Add ${count} bottle${count > 1 ? 's' : ''} to cart · ${formatted}`)
      : tr(panel, 'Choisissez une couleur', 'Select an ink color');
    button.disabled = count === 0 || panel.dataset.eaInkBusy === 'true';
  }

  function showMessage(panel, message, isError = false) {
    const target = panel?.querySelector('[data-ea-ink-message]');
    if (!target) return;
    target.textContent = message;
    target.dataset.eaInkError = isError ? 'true' : 'false';
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const stepButton = event.target.closest('button[data-ea-ink-step]');
    if (!stepButton) return;
    const panel = stepButton.closest(selector);
    if (!panel || panel.dataset.eaInkBusy === 'true') return;
    event.preventDefault();
    const input = stepButton.closest('[data-ea-ink-row]')?.querySelector('[data-ea-ink-quantity]');
    if (!input) return;
    const step = Number(stepButton.dataset.eaInkStep) || 0;
    input.value = String(Math.max(0, Math.min(maxQty, numberOf(input) + step)));
    showMessage(panel, '');
    refresh(panel);
  });

  document.addEventListener('input', (event) => {
    if (!(event.target instanceof Element) || !event.target.matches('[data-ea-ink-quantity]')) return;
    const panel = event.target.closest(selector);
    if (!panel || panel.dataset.eaInkBusy === 'true') return;
    showMessage(panel, '');
    // Let the client finish typing, clamp the entered number on change.
    // 'refresh' clamps immediately too; intentionally simple for mobile.
    refresh(panel);
  });

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element) || !event.target.matches('[data-ea-ink-quantity]')) return;
    refresh(event.target.closest(selector));
  });

  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('button[data-ea-ink-submit]');
    if (!button || button.disabled) return;
    event.preventDefault();
    const panel = button.closest(selector);
    if (!panel || panel.dataset.eaInkBusy === 'true') return;
    const lines = Array.from(panel.querySelectorAll('[data-ea-ink-row]')).flatMap((row) => {
      const input = row.querySelector('[data-ea-ink-quantity]');
      const quantity = numberOf(input);
      return quantity ? [{ merchandiseId: String(row.dataset.eaInkVariant), quantity }] : [];
    });
    if (!lines.length) return;

    panel.dataset.eaInkBusy = 'true';
    button.setAttribute('aria-busy', 'true');
    refresh(panel);
    showMessage(panel, tr(panel, 'Ajout en cours…', 'Adding to cart…'));

    const scope = panel.dataset.eaInkScope || 'page';
    try {
      const updateCart = window.Shopify?.actions?.updateCart;
      if (typeof updateCart !== 'function') {
        throw new Error(tr(panel, 'Le panier est momentanément indisponible. Réessayez.', 'The cart is temporarily unavailable. Try again.'));
      }
      // Un seul ajout natif avec plusieurs bouteilles de couleurs différentes.
      // On n'écrit AUCUNE propriété de ligne d'étampe / BO / personnalisation.
      const result = await updateCart(
        { lines },
        { event: { context: scope === 'drawer' ? 'dialog' : 'cart', detail: { source: 'ea-cart-ink-upsell' } } }
      );
      if (result?.userErrors?.length) {
        throw new Error(result.userErrors.map((error) => error.message).join(' ; '));
      }

      // Le rendu natif Horizon peut remplacer le <details>. Rechercher sa nouvelle instance.
      // Deux frames permettent à la plupart des renders asynchrones de s'achever.
      await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      const currentPanel = document.querySelector(`${selector}[data-ea-ink-scope="${scope}"]`) || panel;
      // Ajout confirmé : refermer le sélecteur automatiquement.
      // En cas d'échec (bloc catch), il demeure ouvert pour réessayer.
      currentPanel.open = false;
      currentPanel.dataset.eaInkBusy = 'false';
      currentPanel.querySelectorAll('[data-ea-ink-quantity]').forEach((input) => { input.value = '0'; });
      currentPanel.querySelector('[data-ea-ink-submit]')?.removeAttribute('aria-busy');
      refresh(currentPanel);
      if (result?.warnings?.length) {
        showMessage(currentPanel, tr(currentPanel, 'Ajout effectué. Certaines quantités ont été ajustées selon le stock.', 'Added to cart. Some quantities were adjusted based on stock.'));
      } else {
        showMessage(currentPanel, tr(currentPanel, 'Bouteille(s) ajoutée(s) au panier ✓', 'Ink bottle(s) added to cart ✓'));
      }
    } catch (error) {
      console.error('Étampes A+ — ajout d’encre :', error);
      // Ne jamais répéter automatiquement : la requête a peut-être réussi côté Shopify.
      const currentPanel = document.querySelector(`${selector}[data-ea-ink-scope="${scope}"]`) || panel;
      currentPanel.dataset.eaInkBusy = 'false';
      showMessage(currentPanel, error?.message || tr(panel, 'Impossible d’ajouter ces bouteilles.', 'Unable to add these bottles.'), true);
      currentPanel.querySelector('[data-ea-ink-submit]')?.removeAttribute('aria-busy');
      refresh(currentPanel);
    } finally {
      panel.dataset.eaInkBusy = 'false';
      button.removeAttribute('aria-busy');
      refresh(panel);
    }
  });
})();
